export const MIN_PITCH = 0.0;
export const MAX_PITCH = 2.0;
export const INCREMENT_PITCH = 0.25;
export const MIN_RATE = 0;
export const MAX_RATE = 2;
export const INCREMENT_RATE = 0.25;
